import { useState } from "react";
import { MoreVertical, Trash } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { Href } from "../../../../Constants/Constants";

const ReminderList = () => {
  const [showCompletedToggle, setShowCompetedToggle] = useState(true);
  return (
    <Fragment>
      <div className="reminder-list-disp">
        <h5>Themeforest Discusssion</h5>
        <h6>Project Discussion</h6>
        <span>11:22 PM | 15 FAB</span>
        <ul className="reminder-disp">
          <li className="reminder-list-toggle">
            <a className="icon-btn bg-transparent" href={Href}><MoreVertical /></a>
            <div className="reminder-contentlist-toggle">
              <ul>
                <li>
                  <a className="icon-btn btn-sm" href={Href}><Trash /></a>
                  <h5>Delete</h5>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <div className="reminder-list">
        <button className={`Show-reminder ${showCompletedToggle ? "" : "d-none"}`} onClick={() => setShowCompetedToggle(!showCompletedToggle)}>Show Completed</button>
        <button className="Hide-reminder" style={showCompletedToggle ? { display: "none" } : { display: "inline-block" }} onClick={() => setShowCompetedToggle(!showCompletedToggle)}>Hide Completed</button>
        <div className="target-reminder-list" style={showCompletedToggle ? { display: "none" } : { display: "block" }}>
          <h5>Session Start</h5>
          <h6>Project Discussion</h6>
          <h6>05:22 PM | 1 JAN</h6>
          <ul className="reminder-disp">
            <li className="reminder-toggle">
              <a className="icon-btn bg-transparent" href={Href}><MoreVertical /></a>
              <div className="reminder-content-toggle">
                <ul>
                  <li>
                    <a className="icon-btn btn-sm" href={Href}><Trash /></a>
                    <h5>Delete</h5>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default ReminderList;
